<template>
  <div id="app" v-loading="pageLoading">
    <router-view/>
  </div>
</template>

<script>

export default {
  computed:{
    pageLoading(){
      return this.$store.state.pageLoading
    }
  }
}
</script>
<style>
#app{
  width: 100%;
  height: 100%;
  box-sizing:border-box;
} 
.el-loading-mask>.el-loading-spinner{
  top: 25% !important;
}
</style>